import Tabs, { TabPane } from 'rc-tabs';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination, Navigation } from 'swiper';
import { Headers } from '../Headers';
import Modal from '../Modal';
import { useState, useEffect } from 'react';
import translate from "./../../../lib/translate/TranslateJs";
SwiperCore.use([Pagination, Navigation])

function WithdrawalTutorialModal(props){
  const {visible, onClose} = props;
  const [selectedKey, setSelectedKey] = useState('1')
  const [withdrawCurrentIndex,setWithdrawCurrentIndex] = useState('0');
  const [addUsdtWalltCurrentIndex,setUsdtWalltCurrentIndex] = useState('0');
  const cryptoWithdrawal = [
    {
        step: `${translate('步骤')()} 1`,
        content: <p className='contentWithTitle' data-CN="輸入金額後請確認虛擬幣金額，匯率僅供參考，交易時使用實時匯率">
          {translate('HowToSubmitWithdrawal_1(desktop)')()}
        </p>,
        stepCN: '步骤1',
    },
    {
        step: `${translate('步骤')()} 2`,
        content: <p className='contentWithTitle' data-CN="輸入虛擬幣錢包地址&姓名">
          {translate('HowToSubmitWithdrawal_2(desktop)')()}
        </p>,
        stepCN: '步骤2',
    },
    {
        step: `${translate('步骤')()} 3`,
        content: <p className='contentWithTitle' data-CN="點擊提款並確認交易狀態">
          {translate('HowToSubmitWithdrawal_3(desktop)')()}
        </p>,
        stepCN: '步骤3',
    },
    {
        step: `${translate('步骤')()} 4`,
        content: <p className='contentWithTitle' data-CN="有關加密貨幣信息，您可以在這些網站上查看">
          {translate('HowToSubmitWithdrawal_4(desktop)')()}
        </p>,
        stepCN: '步骤4',
    },
  ]
  
  const addWithdrawal = [
    // 如果Mockup上有無標題文字垂直置中的狀況，className可以使用contentWithoutTitle
    // 目前Mockup更新為都有標題
    {
        step: `${translate('步骤')()} 1`,
        content: <p className='contentWithTitle' data-CN="點擊添加錢包">
          {translate('HowToAddWallet_1(desktop)')()}
        </p>,
        stepCN: '步骤1',
    },
    {
        step: `${translate('步骤')()} 2`,
        content: <p className='contentWithTitle' data-CN="輸入正確的錢包名稱&地址">
          {translate('HowToAddWallet_2(desktop)')()}
        </p>,
        stepCN: '步骤2',
    },
    {
        step: `${translate('步骤')()} 3`,
        content: <p className='contentWithTitle' data-CN="複製錢包地址或虛擬幣錢包地址">
          {translate('HowToAddWallet_3(desktop)')()}
        </p>,
        stepCN: '步骤3',
    },
    {
        step: `${translate('步骤')()} 4`,
        content: <p className='contentWithTitle' data-CN="前往銀行管理頁面驗證地址，設定預設錢包以加快下次流程">
          {translate('HowToAddWallet_4(desktop)')()}
        </p>,
        stepCN: '步骤4',
    },
    {
        step: `${translate('步骤')()} 5`,
        content: <p className='contentWithTitle' data-CN="有關加密貨幣信息，您可以在這些網站上查看">
          {translate('HowToAddWallet_5(desktop)')()}
        </p>,
    }
  ]
  function tabChange(key){
    setSelectedKey(key)
    setWithdrawCurrentIndex("0");
    setUsdtWalltCurrentIndex("0");
  }
  useEffect(()=>{
    if(visible){
      setSelectedKey('1')
    }
  }, [visible])

  const closedModal =()=>{
    onClose();
    setWithdrawCurrentIndex("0");
    setUsdtWalltCurrentIndex("0");
  }
  return (
    <Modal
      className='tutorialModal'
      visible={visible}
      fullscreen={true}
      title={<Headers title={translate('泰达币提款教程')()} closeBtn={onClose} visibleBtn={false}/>}
    >
      <Tabs key='1' onChange={tabChange} className='usdtWithdrawLesson'>
          <TabPane tab={translate('如何提款泰达币?')()} key="1">
            {/* 為了讓切換時回到第一張 */}
            {selectedKey === '1' && (
              <Swiper
                  slidesPerView={1}
                  spaceBetween={30}
                  keyboard={{
                    enabled: true,
                  }}
                  pagination={{
                      clickable: true,
                  }}
                  navigation={true}
                  className={`withdrawCurrentIndex${withdrawCurrentIndex}`}
                  onSlideChange={(e) => {setWithdrawCurrentIndex(e.activeIndex)}}
              >
                  {cryptoWithdrawal.map((item, index) => {
                      return (
                          <SwiperSlide key={index + 'step'}>
                              <div className="tutorialCard">
                                  <div className={`tutorial_img tutorialPic_Withdrawal_${index+1}`}/>
                                  {item?.step && <h3 data-CN={item.stepCN}>{item.step}</h3>}
                                  {item.content}
                                  <button className='iKnow' onClick={closedModal}>{translate("知道了")()}</button>
                              </div>
                          </SwiperSlide>
                      );
                  })}
              </Swiper>
            )}
          </TabPane>
          <TabPane tab={translate('如何添加钱包地址?')()} key="2">
            {selectedKey === '2' && (
            <Swiper
                slidesPerView={1}
                spaceBetween={30}
                keyboard={{
                  enabled: true,
                }}
                pagination={{
                    clickable: true,
                }}
                navigation={true}
                className={`addUsdtWalltCurrentIndex${addUsdtWalltCurrentIndex}`}
                onSlideChange={(e) => {setUsdtWalltCurrentIndex(e.activeIndex)}}
            >
                {addWithdrawal.map((item, index) => {
                    return (
                        <SwiperSlide key={index + 'step2'}>
                            <div className="tutorialCard">
                                <div className={`tutorial_img tutorialPic_Withdrawal_AddWallet_${index+1}`}/>
                                {item?.step && <h3 data-CN={item.stepCN}>{item.step}</h3>}
                                {item.content}
                                <button className='iKnow' onClick={closedModal}>{translate("知道了")()}</button>
                            </div>
                        </SwiperSlide>
                    );
                })}
            </Swiper>
            )}
          </TabPane>
      </Tabs>
    </Modal>
  )
}

export default WithdrawalTutorialModal
